<template>
  <div>
    <YesNoModal ref="YesNoModal" />
    <ErrorModal ref="ErrorModal"></ErrorModal>
    <Loader ref="Loader"></Loader>
    <v-container fluid grid-list-xs>
      <v-layout fill-height row mr-1 ml-1 mt-2>
        <v-flex xs12 sm12 md12 lg12 xl12>
          <v-card>
            <v-btn v-if="HasAccess('CUSTOMER_MANAGEMENT', 'CREATE')" style="float:right;" color="success --darken-2"
              @click="$router.push('/customer/create')">
              <v-icon>add</v-icon>Add Customer
            </v-btn>
            <v-data-table :headers="headers" :items="items" :search="search" :rows-per-page-items="[25,50,75,100]">
              <template slot="no-data">There are no records</template>
              <template slot="no-results">No matching records found</template>
              <template slot="headerCell" slot-scope="{ header }">
                <span class="subheading font-weight-light text-success text--darken-3" v-text="header.text" />
              </template>
              <template v-slot:items="props">
                <td>{{ props.index+1 }}</td>
                <td>{{ props.item.Name }}</td>
                <td>{{ props.item.ContactTel }}</td>
                <td>{{ props.item.FirstName }} {{ props.item.LastName }}</td>
                <td>{{ props.item.RegionName }}</td>
                <td>{{ props.item.Suburb }}</td>
                <td>{{ props.item.Province }}</td>
                <td>{{ props.item.InActive }}</td>
                <td style="float:right;">
                  <v-menu dense bottom left>
                    <v-btn small slot="activator" color="primary" dark>
                      <v-icon>settings</v-icon>
                    </v-btn>

                    <div
                      v-if="HasAccess('CUSTOMER_MANAGEMENT', 'MODIFY') || HasAccess('CUSTOMER_MANAGEMENT', 'DELETE')">
                      <v-list dense v-for="(action, index) in actionItems" :key="index">
                        <v-list-tile @click="PerformOperation(action, props.item)" v-if="action.access == true">
                          <v-list-tile-action>
                            <v-icon color="primary darken-2">{{ action.icon }}</v-icon>
                          </v-list-tile-action>
                          <v-list-tile-title>{{ action.title }}</v-list-tile-title>
                        </v-list-tile>
                      </v-list>
                    </div>
                    <div v-else>
                      <v-list dense>
                        <v-list-tile>
                          <v-list-tile-title>
                            You have no options
                            available
                          </v-list-tile-title>
                        </v-list-tile>
                      </v-list>
                    </div>
                  </v-menu>
                </td>
              </template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
  import JWT from "jsonwebtoken";

  export default {
    data() {
      let self = this;

      return {
        actionItems: [{
            type: "modify",
            title: "Modify",
            access: self.HasAccess("CUSTOMER_MANAGEMENT", "MODIFY"),
            icon: "edit"
          },
          {
            type: "delete",
            title: "Delete",
            access: self.HasAccess("CUSTOMER_MANAGEMENT", "DELETE"),
            icon: "delete"
          }
        ],
        headers: [{

          },
          {
            sortable: true,
            text: "Name",
            value: "Name"
          },
          {
            sortable: true,
            text: "Contact Telephone Number",
            value: "ContactTel"
          },
          {
            sortable: true,
            text: 'Contact Person',
            value: ''
          },
          {
            sortable: true,
            text: "Region",
            value: "RegionName"
          },
          {
            sortable: true,
            text: "Suburb",
            value: "Suburb"
          },
          {
            sortable: true,
            text: "Province",
            value: "Province"
          },
          {
            sortable: true,
            text: "In-Active",
            value: "InActive"
          },
          {
            sortable: false,
            align: "right",
            text: "Actions"
          }
        ],
        items: [],
        regionItems: []
      };
    },
    props: {
      search: String
    },
    mounted() {
      let self = this;
      let sessionData = self.$store.getters.getUserSessionData;
      let tokenDecoded = JWT.decode(localStorage.accessToken);

      let userID = localStorage.getItem("USER_ID");
      let role = localStorage.getItem("Role");
      //self.fetchRegions(role, userID, self.FetchData);
      self.FetchData(role, userID);
    },
    methods: {
      FetchData(role, userID) {
        let self = this;
        let url;
        self.items = [];

        self.$refs.Loader.show(true);
        self.$refs.Loader.setText("Loading customers...");
        switch (role.toLowerCase()) {
          case "master": {
            url = `Customer`;
          }
          break;
        case "admin": {
          url = `Customer`;
        }
        break;
        default: {
          url = `Customer/GetBySystemUser?systemUserID=${userID}`;
        }
        break;
        }

        self.get(url)
          .then(response => {
            self.$refs.Loader.hide();
            self.items = response.data;
          })
          .catch(error => {
            self.$refs.Loader.hide();
            self.$refs.ErrorModal.show();
            self.$refs.ErrorModal.setText(error.toString());
          });
      },
      PerformOperation(action, item) {
        let self = this;
        switch (action.type.toUpperCase()) {
          case "MODIFY": {
            self.modifyitem(item);
          }
          break;
        case "DELETE": {
          self.deleteItem(item);
        }
        break;
        }
      },
      createVenue(item) {
        let self = this;

        self.$router.push("/venue/create/" + item.ID);
      },
      modifyitem(item) {
        let self = this;

        self.$router.push("/customer/modify/" + item.ID);
      },
      deleteItem(item) {
        let self = this;

        item.IsDeleted = true;
        let Request = item;

        self.$refs.YesNoModal.show(
          "Are you sure you want to delete this customer?",
          function (yes) {
            if (yes == true) {
              self.$refs.Loader.show(true);
              self.$refs.Loader.setText("Deleting customer...");
              self.delete(`Customer?id=${item.ID}`, Request).then(r => {
                  self.$refs.Loader.hide();
                  if (r.data == true) {
                    var index = self.items.indexOf(item);
                    if (index > -1) {
                      self.items.splice(index, 1);
                    }
                  }
                })
                .catch(error => {
                  self.$refs.Loader.hide();
                  self.$refs.ErrorModal.show();
                  self.$refs.ErrorModal.setText(error.toString());
                });
            }
          })


      }
      // deleteItem(item) {
      //   let self = this;

      //   // need to update nd set IsDeleted to true
      //   console.log("CUSTOMER ITEM:", item)
      //   self.$refs.YesNoModal.show(
      //     "Are you sure you want to delete this customer?",
      //     function (yes) {
      //       if (yes == true) {
      //         self.$refs.Loader.show(true);
      //         self.$refs.Loader.setText("Deleting customer...");
      //         self
      //           .delete(`Customer?id=${item.ID}`)
      //           .then(result => {
      //             self.$refs.Loader.hide();
      //             if (result.data == true) {
      //               var index = self.items.indexOf(item);
      //               if (index > -1) {
      //                 self.items.splice(index, 1);
      //               }
      //             }
      //           })
      //           .catch(error => {
      //             self.$refs.Loader.hide();
      //             self.$refs.ErrorModal.show();
      //             self.$refs.ErrorModal.setText(error.toString());
      //           });
      //       }
      //     }
      //   );
      // }
    }
  };
</script>